<template>
  <div class="aside-tools">
    <div class="aside-tools-label">
      <b-icon v-if="icon" :icon="icon" custom-size="default"/>
      <b-dropdown aria-role="list">
        <template #trigger="{ active }">
          <slot name="label"/>
          <b-icon :icon="active ? 'menu-up' : 'menu-down'"></b-icon>
        </template>
        
        
        <b-dropdown-item aria-role="listitem" @click='redirectTo(`VUE_APP_UBIC_SALES_ADDRESS`)'>
          <div class="media">
            <b-icon class="media-left" icon="cash"></b-icon>
            <div class="media-content">
              Продажи
            </div>
          </div>
          </b-dropdown-item>
        <b-dropdown-item class="is-active" aria-role="listitem" @click='redirectTo(`VUE_APP_UBIC_PROD_ADDRESS`)'>
          <div class="media">
            <b-icon class="media-left" icon="pot-steam"></b-icon>
            <div class="media-content">
              Производство
            </div>
          </div>
        </b-dropdown-item>
      </b-dropdown>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AsideTools',
  props: {
    icon: {
      type: String,
      default: null
    },
    label: {
      type: String,
      default: null
    }
  },
  methods: {
    redirectTo(url) {
      window.location.href = process.env[url];
    }
  }
}
</script>

<style scoped lang="scss">
.aside-tools-label {
  cursor: pointer;
}
</style>
